import * as constants from './Studentwork.constants';
import * as services from './Studentwork.service';

const state = {
  studentworkOssPolicy: {},

  assignmentId: -1,

  studentworkList: {},

  objStudentworks: {},

  isRequest: false,
};

const mutations = {
  [constants.GET_STUDENT_WORK_OSS_POLICY_SUCCESS](state, studentworkOssPolicy) {
    if (undefined !== studentworkOssPolicy && null !== studentworkOssPolicy) {
      state.studentworkOssPolicy = studentworkOssPolicy;
    }
  },

  [constants.SET_ASSIGNMENT_ID](state, assignmentId) {
    if (undefined !== assignmentId && null !== assignmentId) {
      state.assignmentId = assignmentId;
    }
  },

  [constants.GET_STUDENT_WORK_LIST_SUCCESS](state, studentworkList) {
    if (undefined !== studentworkList && null !== studentworkList) {
      state.studentworkList = studentworkList;
    }
  },

  [constants.UPDATE_STUDENT_WORK](state, updObjStudentwork) {
    const { fileName } = updObjStudentwork;
    const k = encodeURIComponent(fileName);
    const objStudentwork = state.objStudentworks[k] || {};
    state.objStudentworks = {
      ...state.objStudentworks,
      [k]: {
        ...objStudentwork,
        ...updObjStudentwork,
      },
    };
  },

  [constants.CLEAR_OBJ_STUDENT_WORKS](state) {
    state.objStudentworks = {};
  },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },
};

const actions = {
  async getStudentworkpolicy({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getStudentworkpolicy(payload);
    commit(constants.GET_STUDENT_WORK_OSS_POLICY_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async getStudentworkList({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    commit(constants.GET_STUDENT_WORK_LIST_SUCCESS, {});
    const res = await services.getStudentworkList(payload);
    commit(constants.GET_STUDENT_WORK_LIST_SUCCESS, res.data.data);
    commit(constants.CLEAR_OBJ_STUDENT_WORKS);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async newStudentwork({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.newStudentwork(payload);
    commit(constants.GET_STUDENT_WORK_LIST_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async getStudentwork({ commit }, payload) {
    const { fileName } = payload;
    commit(constants.SET_IS_REQUEST_STATUS, true);
    commit(constants.UPDATE_STUDENT_WORK, {
      fileName,
      isGeneratingUrl: true,
    });
    const res = await services.getStudentwork(payload);
    commit(constants.UPDATE_STUDENT_WORK, {
      fileName,
      isGeneratingUrl: false,
      fileUrl: res.data.data,
    });
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async deleteStudentwork({ commit }, payload) {
    const { fileName } = payload;
    commit(constants.SET_IS_REQUEST_STATUS, true);
    commit(constants.UPDATE_STUDENT_WORK, {
      fileName,
      isDeleting: true,
    });
    const res = await services.deleteStudentwork(payload);
    commit(constants.GET_STUDENT_WORK_LIST_SUCCESS, res.data.data);
    commit(constants.UPDATE_STUDENT_WORK, {
      fileName,
      isDeleting: false,
      fileUrl: undefined,
    });
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },
};

const getters = {
  studentworkList: (state) => state.studentworkList,

  objStudentworks: (state) => (k) => {
    let objStudentwork = state.objStudentworks[k] || {};
    objStudentwork = {
      ...objStudentwork,
      fileUrl: undefined !== objStudentwork.fileUrl ? objStudentwork.fileUrl : '',
      isGeneratingUrl:
        undefined !== objStudentwork.isGeneratingUrl ? objStudentwork.isGeneratingUrl : false,
      isDeleting: undefined !== objStudentwork.isDeleting ? objStudentwork.isDeleting : false,
    };
    objStudentwork = {
      ...objStudentwork,
      c_isLocked: objStudentwork.isGeneratingUrl || objStudentwork.isDeleting,
    };
    return objStudentwork;
  },

  assignmentAttachmentLinkList: (state, getters) => {
    let assignmentAttachmentLinkList = [];
    for (let i = 1; i <= 10; i++) {
      const fileName = getters.studentworkList[`assignmentAttachmentLink${i}`];
      if (fileName) {
        assignmentAttachmentLinkList = [
          ...assignmentAttachmentLinkList,
          {
            fileName,
            ...getters.objStudentworks(encodeURIComponent(fileName)),
          },
        ];
      }
    }
    return assignmentAttachmentLinkList;
  },

  isAssignmentAttachmentFull: (state, getters) => {
    return getters.assignmentAttachmentLinkList.length >= 10;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
